import React, { useEffect, useState } from "react";
import PopUpModal from "../../Components/Modal";
import { Button, Form } from "react-bootstrap";
import * as api from "../../api/getapi";
import * as postapi from "../../api/postapi";
import useApi from "../../Hooks/useApi";
import { toast } from "react-toastify";
import PhoneInput from "../../Components/PhoneInput/PhoneInput";
import SearchableSelect from "../../Components/SearchableSelect";
import ShipOrderWithPostexModal from "../../Components/Orders/ShipOrderWithPostexModal";
import ShipOrderWithTcsModal from "../../Components/Orders/ShipOrderWithTcsModal";
import { RiCheckLine, RiCloseLine } from "react-icons/ri";
import styles from "../../Components/Orders/OrdersWorkspace/OrdersWorkspace.module.css";

const StatusChangeConfirmationModal = ({ show, onHide, toggle, id, status, trx_status, paymentGatewayResponse, orderId, orderSourceId }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [deliveryPersonName, setDeliveryPersonName] = useState("");
  const [deliveryPersonPhone, setDeliveryPersonPhone] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [deliveryPartner, setDeliveryPartner] = useState({});
  const [deliveryPartnersOptions, setDeliveryPartnersOptions] = useState([]);
  const [dontSendSms, setDontSendSms] = useState(false);
  const [postexModalShow, setPostexModalShow] = useState(false);
  const [postexOrder, setPostexOrder] = useState(null);
  const [tcsModalShow, setTcsModalShow] = useState(false);
  const [tcsOrder, setTcsOrder] = useState(null);
  const changeOrderStatus = useApi(postapi.changeOrderStatus, { hasCatchError: true });
  const fetchDeliveryPartners = useApi(api.getDeliveryPartners, { hasCatchError: true });

  const statusMap = {
    Confirmed: "Confirm",
    Picked: "Pick",
    Shipped: "Ship",
    Delivered: "Deliver",
    Returned: "Return",
    Cancelled: "Cancel",
  };

  const statusDescription = {
    Confirmed: "confirm this order? The seller will be notified to prepare the order for pickup.",
    Picked: "mark this order as picked? A delivery partner must be assigned for pickup.",
    Shipped: "mark this order as shipped?",
    Delivered: "mark this order as delivered? The customer and seller will be notified.",
    Returned: "mark this order as returned? A reason is required.",
    Cancelled: "cancel this order? A reason is required.",
  };

  const close = () => {
    setIsClicked(false);
    onHide();
    setDontSendSms(false);
    setError("");
    setDeliveryPersonName("");
    setDeliveryPersonPhone("");
    setTrackingId("");
    setDeliveryPartner({});
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var response;
      setValidated(true);
      if (status === "Picked") {
        if (deliveryPartner?.label ? (deliveryPartner?.label === "Techbazaar" ? deliveryPersonName !== "" && deliveryPersonPhone !== "" : trackingId !== "") : false) {
          setIsClicked(true);
          const obj = {
            id,
            status,
            postman_name: deliveryPersonName,
            postman_phone: deliveryPersonPhone,
            delivery_partner_id: deliveryPartner.value,
            delivery_partner_label: deliveryPartner.label,
            tracking_id: trackingId,
            send_sms: !dontSendSms,
          };
          response = await changeOrderStatus.request(obj);
        }
      } else {
        setIsClicked(true);
        response = await changeOrderStatus.request({ id, status, trx_status, send_sms: !dontSendSms });
      }
      if (response.status === 200) {
        toast.success(`${response?.data?.data?.message}`, {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        setValidated(false);
        setDeliveryPersonName("");
        setDeliveryPersonPhone("");
        setTrackingId("");
        setDeliveryPartner({});
        setDontSendSms(false);
        close();
        toggle();
      }
    } catch (error) {
      setError(error.response.data.error.message);
      setValidated(false);
      toggle();
    }
  };

  const fetchAllDeliveryPartners = async () => {
    try {
      const res = await fetchDeliveryPartners.request();
      const options = res?.data?.data?.map((item) => ({ label: item.name, value: item.id }));
      setDeliveryPartnersOptions(options);
    } catch (error) {
      console.log(error.response.data.message);
      return [];
    }
  };
  useEffect(() => {
    fetchAllDeliveryPartners();
  }, [status === "Picked"]);

  useEffect(() => {
    if (show && status === "Picked" && deliveryPartner?.label === "PostEx") {
      const chosenOrderId = orderSourceId ? orderSourceId : id;
      setPostexOrder({ id: chosenOrderId });
      setPostexModalShow(true);
      onHide();
    } else if (show && status === "Picked" && deliveryPartner?.label === "TCS") {
      const chosenOrderId = orderSourceId ? orderSourceId : id;
      setTcsOrder({ id: chosenOrderId, deliveryPartnerId: deliveryPartner?.value });
      setTcsModalShow(true);
      onHide();
    }
  }, [show, status, deliveryPartner?.label, orderId, orderSourceId, id, onHide]);

  return (
    <>
      <PopUpModal title={`${statusMap[status]} Order`} show={show} onHide={close} closeButton={false}>
        <>
          {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}

          <div>
            <span className="d-flex justify-content-center pb-4 text-center">Are you sure you want to {statusDescription[status] || `change the status to ${status}?`}</span>
          </div>
          {paymentGatewayResponse && (
            <div className="mb-3 p-3 border rounded" style={{ backgroundColor: "#f8f9fa" }}>
              <h6 className="mb-2">Payment Gateway Response:</h6>
              <div className="small">
                {Object.entries(paymentGatewayResponse).map(([key, value]) => (
                  <div key={key} className="d-flex justify-content-between py-1 border-bottom">
                    <strong>{key}:</strong>
                    <span className="text-end ms-2">{typeof value === "object" ? JSON.stringify(value) : String(value)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {status === "Picked" ? (
            <Form noValidate validated={validated}>
              <Form.Group className="my-3">
                <label>
                  Delivery Partner<span className="text-danger">*</span>{" "}
                </label>
                <SearchableSelect
                  placeholder="Delivery Partner"
                  name="deliveryPartner"
                  options={deliveryPartnersOptions}
                  handleChange={(e) => {
                    setDeliveryPartner(e);
                  }}
                  value={deliveryPartner}
                  required
                />
                {validated && Object.keys(deliveryPartner)?.length === 0 && (
                  <div className="text-danger mt-2" style={{ fontSize: "0.875rem" }}>
                    Enter Delivery Partner
                  </div>
                )}
              </Form.Group>
              {deliveryPartner?.label === "Techbazaar" ? (
                <>
                  <Form.Group>
                    <label>
                      Delivery Person Name<span className="text-danger">*</span>
                    </label>
                    <Form.Control
                      type="text"
                      placeholder="Delivery Person Name"
                      required
                      name="deliveryPersonName"
                      maxLength={35}
                      value={deliveryPersonName}
                      onChange={(e) => {
                        setDeliveryPersonName(e.target.value);
                      }}
                    />
                    <Form.Control.Feedback type="invalid">Enter Delivery Person Name.</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="my-3">
                    <label>
                      Delivery Person Phone<span className="text-danger">*</span>
                    </label>
                    <PhoneInput placeholder="+92-3XX-XXXXXXX" value={deliveryPersonPhone} onChange={(e) => setDeliveryPersonPhone(e.target.value)} required />
                    <Form.Control.Feedback type="invalid">* Please Enter Delivery Person Phone Number</Form.Control.Feedback>
                  </Form.Group>
                </>
              ) : (
                <></>
              )}

              <Form.Group className="my-3">
                <label>Tracking Id{deliveryPartner.label !== "Techbazaar" && <span className="text-danger">*</span>}</label>
                <Form.Control type="text" placeholder="Tracking Id" name="trackingId" value={trackingId} onChange={(e) => setTrackingId(e.target.value)} maxLength={20} required={deliveryPartner.label !== "Techbazaar"} />
                <Form.Control.Feedback type="invalid">Enter Tracking Id</Form.Control.Feedback>
              </Form.Group>
            </Form>
          ) : (
            <></>
          )}
          <Form.Group className="mb-3">
            <Form.Check type="switch" id="dont-send-sms-toggle" label="Don't Send SMS" checked={dontSendSms} onChange={(e) => setDontSendSms(e.target.checked)} />
          </Form.Group>
          <div className={styles.modalActions}>
            <Button className={styles.modalAction} variant="outline-secondary" onClick={close}>
              <RiCloseLine aria-hidden="true" /> Cancel
            </Button>
            <Button className={styles.modalAction} variant="primary" onClick={handleSubmit} disabled={isClicked}>
              <RiCheckLine aria-hidden="true" /> {statusMap[status]}
            </Button>
          </div>
        </>
      </PopUpModal>
      {/* PostEx shipping modal rendered alongside; parent show state is independent */}
      <ShipOrderWithPostexModal
        show={postexModalShow}
        onHide={() => {
          setPostexModalShow(false);
          setPostexOrder(null);
          close();
        }}
        order={postexOrder}
        toggle={toggle}
      />
      <ShipOrderWithTcsModal
        show={tcsModalShow}
        onHide={() => {
          setTcsModalShow(false);
          setTcsOrder(null);
          close();
        }}
        order={tcsOrder}
        toggle={toggle}
      />
    </>
  );
};

export default StatusChangeConfirmationModal;
